export const formatMoney = (value, currency = "MAD") => {
  const n = Number(value || 0);
  return new Intl.NumberFormat("fr-MA", { style: "currency", currency }).format(n);
};

export const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

export const toPercent = (n, digits = 0) => `${Number(n || 0).toFixed(digits)}%`;

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Intl.DateTimeFormat("en-GB", { year: "numeric", month: "short", day: "2-digit" }).format(d);
};

export const monthKey = (iso) => {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};
